<template>
  <v-navigation-drawer v-model="drawer" app clipped>
    <v-list>
      <div v-for="datatypeName in visibleDatatypes">
        <v-list-item v-if="datatypes[datatypeName]" link :to="'/data/' + datatypeName">
          <v-list-item-icon v-if="datatypes[datatypeName] && datatypes[datatypeName].icon">
            <v-icon>{{ datatypes[datatypeName].icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="datatypes[datatypeName] && datatypes[datatypeName].title" :to="/data/">
            <v-list-item-title>{{ datatypes[datatypeName].title[language] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-else />
      </div>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'lean-navigation-drawer',
  props: {
    drawer: { type: Boolean, required: true }
  },
  computed: {
    visibleDatatypes: {
      get() {
        if (this.$store.state.config.datatypes && this.$store.state.config.datatypes.menu) {
          return this.$store.state.config.datatypes.menu;
        } else {
          return Object.keys(this.$store.state.models);
        }
      }
    },
    language: {
      get() {
        return this.$store.state.selectedLanguage;
      },
      set(value) {
        this.$root.$i18n.locale = value.split('_').shift().toLowerCase();
        this.setSelectedLanguage(value);
      }
    },
    ...mapState({
      datatypes: (state) => state.models
    })
  },
  method: {
    ...mapMutations({
      setSelectedLanguage: 'setSelectedLanguage'
    })
  }
};
</script>
